import Label from '../../../element/ui/core/label';
import { Stage } from '../../../../../react-konva';
import styled from 'styled-components';

/** Default preview size before container measure (280px panel − padding). */
export const FILTER_CARD_PREVIEW_WIDTH = 248;
export const FILTER_CARD_PREVIEW_HEIGHT = 140;

export const StyledFiltersPanel = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  box-sizing: border-box;
`;

export const StyledFiltersList = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 0;
  overflow-x: hidden;
  overflow-y: auto;
  box-sizing: border-box;
  background: transparent;
  border: none;
  box-shadow: none;
  border-radius: 0;
  padding: 0 10px 14px;
`;

export const StyledFilterItem = styled.button`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  margin: 0 0 12px;
  padding: 10px;
  cursor: pointer;
  text-align: left;
  font: inherit;
  color: var(--theme-text-on-panel, var(--primary-text-color, #1f2a44));
  background: var(--theme-action-surface, #ffffff);
  border: 1px solid var(--theme-panel-border, #dee1ec);
  border-radius: 6px;
  box-shadow: 0 1px 2px var(--theme-shadow, rgba(15, 23, 42, 0.08));
  box-sizing: border-box;
  transition: background 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease;

  &:hover {
    background: var(--theme-action-surface-hover, #f8fafb);
    border-color: var(--theme-border-on-dark-strong, #b8c4d9);
  }

  &[aria-selected='true'] {
    border-color: var(--theme-tool-card-selected-border, #ffa1c5);
    box-shadow: 0 0 0 1px var(--theme-tool-card-selected-border, #ffa1c5),
      0 2px 8px rgba(248, 85, 142, 0.18);
    background: var(--theme-action-surface, #ffffff);
  }
`;

export const StyledFilterItemPreviewWrap = styled.div`
  width: 100%;
  border-radius: 4px;
  overflow: hidden;
  background: var(--theme-workspace, #e8ecf2);
  line-height: 0;
`;

export const FilterItemPreview = styled(Stage)`
  display: block;
`;

export const FilterItemLabel = styled(Label)`
  margin: 10px 0 0;
  padding-top: 2px;
  font-family: Poppins, system-ui, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.2;
  text-align: center;
  color: var(--theme-text-on-panel, var(--primary-text-color, #1f2a44));

  ${StyledFilterItem}[aria-selected='true'] & {
    color: var(--accent-primary-active, #f8558e);
    font-weight: 600;
  }
`;
